import { Box, Flex, HStack } from '@skin-seoul/design-system';
import { Skeleton } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';

type VerticalProductCardSkeletonProps = ComponentProps<typeof Flex>;

export const VerticalProductCardSkeleton = ({ ...props }: VerticalProductCardSkeletonProps) => {
  return (
    <Flex direction="column" gap={4} width="100%" cursor="pointer" minWidth={0} {...props}>
      <Box
        borderRadius="8px"
        background="neutral.50"
        overflow="hidden"
        height={{
          base: '200px',
          tablet: '300px',
        }}
        width="100%"
        minWidth={0}
        position="relative"
      >
        <Box position="absolute" top={3} right={3} zIndex={2}>
          <Skeleton width="24px" height="24px" borderRadius="12px" />
        </Box>

        <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" width="80%" height="70%">
          <Skeleton width="100%" height="100%" borderRadius="4px" />
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap={3} width="100%" minWidth={0} borderRadius="0 0 8px 8px">
        <Box display="flex" flexDirection="column" gap={2} width="100%" minWidth={0}>
          <Skeleton borderRadius="4px" height="16px" width="120px" />
          <Skeleton borderRadius="4px" height="16px" width="100%" />
        </Box>

        <HStack alignItems="center" gap={2}>
          <Skeleton borderRadius="4px" height="20px" width="80px" />
          <Skeleton borderRadius="4px" height="14px" width="60px" />
        </HStack>

        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton borderRadius="4px" height="16px" width="60px" />
        </Box>
      </Box>
    </Flex>
  );
};
